export const rankingYears = [2023, 2022];
export const rankingLastYear = rankingYears[0];
export const rankingYears = [2023, 2022];
export const rankingLastYear = rankingYears[0];
